<template>
	<edit></edit>
</template>

<script>
	import edit from './reward_gift_edit.vue'
	
	export default {
		name: 'reward_gift_add',
		
		components: {
			edit
		}
	}
</script>